<template>
  <v-container class="pa-0">
    <loading-spinner v-if="loading || _.isEmpty(heatmap)"> </loading-spinner>
    <v-row v-else>
      <v-col cols="12" class="secondary--text">
        <v-card>
          <v-row dense>
            <v-col cols="auto">
              <v-card-text class="pr-0">
                <v-img :src="$images.HEATMAP" width="30"></v-img>
              </v-card-text>
            </v-col>
            <v-col>
              <v-card-title>
                360 Review Heatmap
              </v-card-title>
            </v-col>
            <v-spacer class="limited-spacer"></v-spacer>
            <v-col
              class="my-auto pr-4"
              :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'"
            >
              <timeframe-select
                v-model="filter"
                v-on:change="refreshData"
              ></timeframe-select>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <div class="heatmap-scroll">
            <div class="heatmap-wrap">
              <table class="heatmap">
                <heatmap-col-group :headers="headers"></heatmap-col-group>
                <heatmap-head
                  :headers="headers"
                  :selectedColumns="selectedColumns"
                >
                </heatmap-head>
                <tbody>
                  <heatmap-row
                    count
                    title="Number of Responses"
                    :standard_value="{ value: standard_count }"
                    :values="counts"
                    dark
                    small
                  >
                  </heatmap-row>
                  <heatmap-row
                    title="Overall 360 Score"
                    bold
                    :standard_value="standard_value({ id: null })"
                    :values="values({ id: null })"
                  >
                  </heatmap-row>
                  <heatmap-row
                    v-for="(item, i) in items"
                    :key="i"
                    :title="item.name"
                    :standard_value="standard_value(item)"
                    :values="values(item)"
                  >
                    <template v-slot:titleExtension>
                      <v-tooltip top v-if="item.description">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="lighttext"
                            small
                            class=" ml-2"
                          >
                            help
                          </v-icon>
                        </template>
                        <div class="tooltip-limit-width">
                          {{ item.description }}
                        </div>
                      </v-tooltip>
                    </template>
                  </heatmap-row>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeatmapRow from "@/components/common/HeatmapRow";
import HeatmapColGroup from "@/components/common/HeatmapColGroup";
import HeatmapHead from "@/components/common/HeatmapHead";
import { mapGetters } from "vuex";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
export default {
  name: "ReviewHeatmap",
  components: { HeatmapRow, HeatmapColGroup, HeatmapHead, TimeframeSelect },
  props: { filter: { type: Object } },
  data: () => ({
    loading: false,
    selectedColumns: []
  }),
  computed: {
    items() {
      return this.heatmap.rows;
    },
    standard_count() {
      return (this.heatmap.counts.find(y => y.id == null) || { count: 0 })
        .count;
    },
    standard_value() {
      return item => {
        let score = (
          this.heatmap.items.find(
            y => y.reviewCategoryId == item.id && y.id == null
          ) || { score: 0 }
        ).score;

        return {
          value: score
        };
      };
    },

    counts() {
      return this.heatmap.columns.map(x => {
        let score = (
          this.heatmap.counts.find(y => y.id == x.id) || {
            count: 0
          }
        ).count;

        return { value: score };
      });
    },
    values() {
      return item => {
        return this.heatmap.columns.map(x => {
          let score = (
            this.heatmap.items.find(
              y => y.reviewCategoryId == item.id && y.id == x.id
            ) || { score: 0 }
          ).score;

          return {
            value: score,
            hideValues: x.hideValues
          };
        });
      };
    },
    headers() {
      let list = [
        { value: "name", text: "", sortable: false, width: 250 },
        {
          value: "overall",
          text: "Company Average",
          sortable: false,
          angled: true,
          width: 30,
          disabled: false,
          bold: true
        }
      ];

      list = list.concat(
        this.heatmap.columns.map(x => ({
          value: x.id,
          text: x.name,
          sortable: false,
          angled: true,
          width: 30,
          disabled: true
        }))
      );

      list.push({ value: "empty", text: "" });

      return list;
    },
    ...mapGetters({
      heatmap: "reporting/heatmap",
      profile: "profile/profile"
    })
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.$store
        .dispatch("reporting/getReviewHeatmap", this.filter)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading pulse heatmap."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
